import { useCallback as u } from "react";
const c = (t, o = null, i = 0) => u(
  (...e) => {
    typeof t == "function" && requestAnimationFrame(() => setTimeout(() => t(...e), i));
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [...o ? [...o] : [t], i]
);
export {
  c as useYieldCallback
};
//# sourceMappingURL=use-yield-callback.js.map
